<div id="collapseOne" class="collapse show" [style.overflow]="overflow"
    [@toggleAnimation]="expanded ? 'open' : 'closed'" (@toggleAnimation.start)="onAnimationEvent($event)"
    (@toggleAnimation.done)="onAnimationEvent($event)" aria-labelledby="headingOne" data-parent="#accordionExample">
    <ng-content></ng-content>
</div>